import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgMiscAiGuardrails = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#2D2E2E"
      d="M15 8H9v2.683c0 1.744.497 2.81 1.129 3.572.49.59 1.121 1.068 1.871 1.52.751-.452 1.383-.928 1.873-1.52.63-.76 1.127-1.827 1.127-3.572V8Zm1.992 3.084c-.153 4.073-2.635 5.744-4.992 6.985l-.456-.247c-2.207-1.22-4.393-2.928-4.536-6.738L7 10.683V6h10v4.683l-.008.401ZM19.787 17.213 18.5 15l-1.287 2.213L15 18.5l2.213 1.287L18.5 22l1.287-2.213L22 18.5l-2.213-1.287Z"
    />
    <path
      fill="#2D2E2E"
      d="M5 10c0 4.81 1.97 7.76 7 10.38a23.37 23.37 0 0 0 1.645-.94l1.926 1.113c-1.14.8-2.364 1.464-3.571 2.067C7.63 20.43 3 17.46 3 10V6h2v4ZM21 10c0 1.905-.304 3.516-.825 4.898l-1.387-2.402c.143-.774.212-1.603.212-2.496V4H3V2h18v8Z"
    />
  </svg>
);
export default SvgMiscAiGuardrails;
